import axios from 'axios';

const getUsers = (grupoId, params) => axios.get(`grupo-compras/${grupoId}/entidades/usuarios`, { params });
const getUsersEntidade = (idEntidadeGrupo, params) => axios.get(`grupo-compras/entidades/${idEntidadeGrupo}/usuarios/nao-vinculados`, { params });

export default {
  getUsers,
  getUsersEntidade,
};
